<template>
  <span class="astro-label">
    <span v-if="name" class="astro-label__name">{{ name }}</span>
    <span
      v-if="symbol"
      class="astro-symbol"
      :class="`astro-symbol--${category}`"
      :style="symbolStyle"
    >{{ symbol }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { symbolStyleVars } from '@/utils/astroTypography';

const props = defineProps({
  category: {
    type: String,
    required: true,
    validator: (value) => ['planet', 'sign', 'aspect'].includes(value),
  },
  name: {
    type: String,
    default: '',
  },
  symbol: {
    type: String,
    default: '',
  },
  settings: {
    type: Object,
    required: true,
  },
  canonicalId: {
    type: String,
    default: '',
  },
});

const symbolStyle = computed(() => symbolStyleVars(props.category, props.settings, props.canonicalId));
</script>
